import React from 'react'
import { AumChart } from '../../redux-store/types/api-types';
import { MPOWER_ACCOUNT_TYPE_MASTER } from '../../utils/constant';

type Props = {

}

const MPOWER_ACCOUNT_TYPE: { [key: string]: string } = {
    POA: "POA",
    EXY: "EXECUTIONARY",
    ADV: "ADV",
    EXECUTIONARY: "EXECUTIONARY",
    ADVISORY: "ADV",
    HLDAWY: "HELD AWAY"
}

const useAumTableHook = () => {

    const getAumTable = (array: Array<AumChart>) => {
        const familyName: Array<string> = [];
        const individual: Array<string> = [];
        const sortedArray = array.sort((a: AumChart, b: AumChart) => Number(b.activationDate) - Number(a.activationDate))

        sortedArray?.reduce((prev = [], curr: AumChart): any => {
            if (!individual.includes(curr.customer)) {
                individual.push(curr.customer);
            }


            // (curr.familyName === "Not Applicable" || curr.familyName === null)
            if (!familyName.includes(curr.familyName)) {
                familyName.push(curr.familyName);
                // if you are changing family name key make your changes here family list array condition key
            }
            return prev;
        }, []);

        const individualArray: Array<any> = [];

        individual.reduce((prev = [], curr: string): any => {
            const data = array.map((item: AumChart) => {
                if (item.customer === curr) {
                    return {
                        customerName: item.customerName,
                        familyName: item.familyName,
                        portfolioName: item.portfolioName,
                        child: false,
                        list: [],
                        ofBook: 0,
                        clientCode: item.customer,
                        marketValue: Number(item.netAssets),
                        investedValue: item.capital,
                        unrealised: item.unrelGainLoss,
                        portfoiloId: item.portfolio,
                        cash: item.cashBalance,
                        return: item.return,
                        irr: (item.return * Number(item.netAssets)) / Number(item.netAssets) || 0,
                        id: Math.floor((Math.random() * 10000) + 1),
                        familyCode: '',
                        isPortfolioHeldaway: item?.isPortfolioHeldaway ?? false,
                        accountType: MPOWER_ACCOUNT_TYPE[`${item?.cusAccountType ?? ''}`.toUpperCase()] ?? item?.cusAccountType ?? '-',
                        modeOfHolding: item?.modeOfHolding,
                        trailAssetsAUM: item?.trailAssetsAUM,
                        riskProfileId: item?.riskProfileId,
                        rmName: item?.relationManagerName,
                        uccCode: item?.uccCode ?? '',
                    }
                }
            });

            const indidArray = data.filter((item: any) => item);
            individualArray.push(indidArray);

        }, []);



        const individualArray2 = individualArray.map((item: any) => {
            return {
                customerName: item[0]?.customerName,
                familyName: item[0]?.familyName,
                portfolioName: item[0]?.portfolioName,
                portfoiloId: item[0]?.portfoiloId,
                familyCode: item[0]?.familyCode,
                child: true,
                list: item,
                ofBook: 0,
                clientCode: item[0].clientCode,
                investedValue: item.reduce((prev = 0, curr: any) => prev + curr.investedValue, 0),
                marketValue: item.reduce((prev = 0, curr: any) => prev + curr.marketValue, 0),
                unrealised: item.reduce((prev = 0, curr: any) => prev + curr.unrealised, 0),
                cash: item.reduce((prev = 0, curr: any) => prev + curr.cash, 0),

                irr: item.reduce((prev = 0, curr: any) => prev + ((curr.return * curr.marketValue)), 0) / item.reduce((prev = 0, curr: any) => prev + curr.marketValue, 0) || 0,

                id: Math.floor((Math.random() * 10000) + 1),
                return: item.reduce((prev = 0, curr: any) => prev + curr.return, 0),
                isPortfolioHeldaway: item?.[0]?.isPortfolioHeldaway ?? false,
                // accountType: item[0]?.accountType ?? '-',
                // modeOfHolding: item[0]?.modeOfHolding,
                trailAssetsAUM: item[0]?.trailAssetsAUM,
                riskProfileId: item[0]?.riskProfileId,
                rmName: item[0]?.rmName,
                uccCode: item[0]?.uccCode ?? '',
            }

        })

        //family

        const familyArray1: any[] = []
        familyName.filter((item) => item !== "Not Applicable" && item).reduce((prev: string, curr: string): any => {
            const data = individualArray2.map((item) => {
                if (item.familyName === curr) {
                    return {
                        ...item,
                        customerName: item.customerName,
                        familyName: item.familyName,
                    }
                }
            })

            const data1 = data.filter((item: any) => item);

            familyArray1.push(data1);

        }, '')

        const familyArray2 = familyArray1.map((item) => {

            const irr = () => {
                const upperValue = item.reduce((prev = 0, curr: any) => prev + curr.list.reduce((prev = 0, curr1: any) => prev + (curr1.return * curr1.marketValue), 0), 0)


                const lowerValue = item.reduce((prev = 0, curr: any) => prev + curr.list.reduce((prev = 0, curr1: any) => prev + (curr1.marketValue), 0), 0)


                return upperValue / lowerValue
            }


            return {
                familyName: ((item[0]?.familyName === "Not Applicable" || item[0]?.familyName === null) ? item[0]?.customerName : item[0]?.familyName),
                // familyName: item?.[0]?.customerName,
                family: true,
                customerName: item[0]?.customerName,
                portfolioName: item[0]?.portfolioName,
                portfoiloId: item[0]?.portfoiloId,
                clientCode: item[0]?.clientCode,
                familyCode: item[0]?.familyCode,
                child: true,
                list: item,
                ofBook: 0,
                investedValue: item.reduce((prev = 0, curr: any) => prev + curr.investedValue, 0),
                marketValue: item.reduce((prev = 0, curr: any) => prev + curr.marketValue, 0),
                unrealised: item.reduce((prev = 0, curr: any) => prev + curr.unrealised, 0),
                cash: item.reduce((prev = 0, curr: any) => prev + curr.cash, 0),
                irr: irr(),
                id: Math.floor((Math.random() * 10000) + 1),
                return: item.reduce((prev = 0, curr: any) => prev + curr.return, 0),
                isPortfolioHeldaway: item?.[0]?.isPortfolioHeldaway ?? false,
                // accountType: item[0]?.accountType ?? '-',
                // modeOfHolding: item[0]?.modeOfHolding,
                trailAssetsAUM: item[0]?.trailAssetsAUM,
                riskProfileId: item[0]?.riskProfileId,
                rmName: item[0]?.rmName,
                uccCode: item[0]?.uccCode ?? '',
            }
        })

        // console.log('individualArray2', individualArray2)

        return {
            individual: individualArray2,
            family: familyArray2
        }
    }

    return {
        getAumTable
    }
}

export default useAumTableHook